export default "__VITE_ASSET__Cs4kc6mG__"